export const cashInitialTouched = {
  amountCash: true,
};

export const cashInitialValues = {
  amountCash: '',
};
